<div class="home-page">
  <app-home-hero [slides]="slides"></app-home-hero>

  <app-home-operations-panel
    *ngIf="actionColumns.length"
    [columns]="actionColumns"
    (navigate)="navigateTo($event)">
  </app-home-operations-panel>

  <app-home-acx-cta (access)="openAcxPlatform()"></app-home-acx-cta>

  <footer class="home-page__footer">
    <p class="home-page__footer-text">
      B3SA© {{ currentYear }} Plataforma de Carbono. Todos os direitos reservados.
    </p>
  </footer>
</div>
